<ng-container *ngIf="!loading">
  <ul class="switch-list">
    <ng-container *ngFor="let item of items; let i = index">
      <li
        (click)="changeActiveItem(item, i)"
        [ngStyle]="{
          'background-color': item.active ? item.bgColor : 'transparent'
        }"
        [ngClass]="{
          'font-bold text-base': item.active,
          'bg-transparent': isChanging,
        }"
        class="switch-item"
      >
        <p class="text-sm lg:text-base" [ngClass]="{ 'text-black': item.active }">{{ item.title }}</p>
      </li>
    </ng-container>
    <span
      class="animation-bg"
      [ngClass]="{
      'is-changing': isChanging,
    }"
      [ngStyle]="{
        '--translateX': translatePercent,
        '--background-color': selectedItem?.bgColor
      }"
    ></span>
  </ul>
</ng-container>
